import React, { useEffect, useState } from "react";
import {
  Button,
  CardActionArea,
  CardContent,
  colors,
  Container,
  Grid,
  Hidden,
  LinearProgress,
  makeStyles,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import BalanceCustRPTForm from "./balanceCustRPT-form";
import { useHistory } from "react-router-dom";

import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import {
  useStylesSpDial,
  useStylesUiElemment,
} from "../St/Reports/UseStyle";
import moment from "moment";
import { insh as inshst } from "../Context/InshSt";
import { SAdefaultValues } from "./balanceCustRPT-services";
import BalanceCustRPTTable from "./balanceCustRPT-table";
import { URL } from "../api/customer";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import { TableChart } from "@material-ui/icons";
import { balanceTypes } from "./balanceCustRPT-services";
import TotalsCard from "./TotalsCard";
import BalanceCutomerTable from "./balanceCustsTable";
import SelectTypesFilter from "./balanceCustRPT-typeFilter";
import { uri } from "../help/Api";
import OrderCard from "./components/order-card";
import CustomerCard from "./components/customer-card";
import useFetchURL from "../components/Hooks/useFetchURL";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#ffffff",
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
  },

  headerTitle: {
    backgroundColor: colors.red[30],
    textAlign: "center",
    fontSize: 20,
    width: "100%",
    fontWeight: "bold"
  },

  blCard: {
    backgroundColor: "#fff",
    borderColor: "#81007f",
  },
  root3: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: colors.red[300],
    direction: "rtl",
    marginTop: 5,
    padding: 5,
    // boxShadow:'box-shadow: rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;',
    boxShadow:
      "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;",
  },
}));

export default function BalanceCustRPT(props) {
  const { AutoOptions } = props;
  let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";
  const [rptParams, setRptParams] = React.useState({
    ...SAdefaultValues,
    dateFrom: from_date,
    account: AutoOptions?.Accindex[0],
  });
  const classes = useStyles();
  const clasui = useStylesUiElemment();
  const clasSp = useStylesSpDial();

  const { data, fetching, } = useFetchURL({ ...{ url: uri + `orders`, dependencyArray: [] } });
  // const fetchDataClick = async () => {
  //   setFetching(true);
  //   setTotals({});
  //   console.log("the type is", rptParams?.type);
  //   await axios
  //     .get(
  //       uri +
  //       `/orders`
  //     )
  //     .then((res) => {
  //       console.log("the res is", res);
  //       // let nData = res?.data?.accountsData.map((d) => {
  //       //   return {
  //       //     ...d,
  //       //     balance: (d?.end_Dept + d?.end_Credit).toFixed(2),
  //       //     state: d?.end_Dept == 0 ? "-" : d?.end_Dept > 0 ? "مدين" : "دائن",
  //       //   };
  //       // });
  //       setData(res.data?.data);
  //       // setTotals(res?.data?.totals);
  //     });
  //   setFetching(false);
  // };

  const [style, setStyle] = useState(inshst.custm);
  const { t } = useTranslation(["forms"]);
  useEffect(() => {
    console.log(" the balance ", data);
  }, [data]);
  const his = useHistory();
  const toBack = () => {
    his.push({ pathname: "/" });
  };
  const viewHandle = (order) => {
    console.log("the order is", order)
    his.push({ pathname: "/order-details", state: order });
    window.location.reload(false);
  };

  
  return (
    <div className={classes.root}>
      <Grid container item xs={12}>
        <Typography size="small" className={classes.headerTitle}>
          Orders Management
        </Typography>
      </Grid>
      <Typography component="div" style={{ direction: "rtl" }}>
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            padding: "10px",
            paddingBottom: "0px",
            borderBottomColor: "faf1f1",
            borderBottomWidth: "2px",
            borderBottomStyle: "solid",
          }}
        >
          <SelectTypesFilter {...{ rptParams, setRptParams }} />
          {/* <BalanceCustRPTForm
            {...{
              AutoOptions,
              rptParams,
              setRptParams,
              onChangeData,
              onChangeAutoData,
              printHandle,
            }}
          /> */}
          <Grid
            container
            justifyContent="center"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            spacing={1}
          >
            {/* <Hidden only={["xs"]}>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={{ ...style.iconBtn, borderRadius: 0 }}
                className={[clasui.button]}
                // onClick={fetchDataClick}
              >
                {t("forms:view")}
              </Button>
            </Grid>
            </Hidden>

            <Hidden smUp={["sm"]}>
            <Grid item>
              <Button
                disabled={fetching}
                variant="contained"
                startIcon={<ScannerIcon />}
                size="large"
                style={{ ...style.iconBtn, borderRadius: 0 }}
                className={[clasui.button]}
                onClick={fetchDataClick}
              >
                {t("forms:show")}
              </Button>
            </Grid>
            </Hidden> */}

            <Grid item>
              {/* <Button
                variant="contained"
                startIcon={<PrintIcon />}
                color="primary"
                size="large"
                className={[clasui.button, clasSp.clSec]}
                style={{ ...style.iconBtn, borderRadius: 0 }}
                // disabled={true}
                onClick={printHandle}
              >
                {t("forms:print")}{" "}
              </Button> */}
            </Grid>
            {/* <Grid item>
              <Button
                variant="contained"
                startIcon={<KeyboardReturnSharpIcon />}
                color="secondary"
                size="large"
                className={[clasui.button, clasSp.clcan]}
                style={{ ...style.iconBtn, borderRadius: 0 }}
                onClick={toBack}
              >
                {t("forms:exit")}
              </Button>
            </Grid> */}
          </Grid>
        </Container>
        {/* <Container maxWidth={true} style={{ padding: "4px" }}>
          <Grid container spacing={1} style={{ paddingTop: "10px" }}>
            <Grid item lg={2} md={2} sm={4} xs={6}>
              <TotalsCard
                {...{
                  title: t("initial-balance"),
                  dept: totals?.totOpenDept?.toFixed(2),
                  credit: totals?.totOpenCredit?.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={3} xs={6}>
              <TotalsCard
                {...{
                  title: t("prev-balance"),
                  dept: totals?.totOpenDept?.toFixed(2),
                  credit: totals?.totOpenCredit?.toFixed(2),
                }}
              />
            </Grid>
            <Grid item lg={2} md={2} sm={3} xs={6}>
              <TotalsCard
                {...{
                  title: t("acc-move"),
                  dept: totals?.totDept?.toFixed(2),
                  credit: totals?.totCredit?.toFixed(2),
                }}
              />
            </Grid>

            <Grid item lg={2} md={2} sm={4} xs={6}>
            
              <TotalsCard
                {...{
                  title: "رصيد الحساب",
                  dept: totals?.totEndDept?.toFixed(2),
                  credit: totals?.totEndCredit?.toFixed(2),
                }}
              />

            </Grid>
          </Grid>
        </Container> */}
        <Container
          component={Paper}
          maxWidth={false}
          style={{
            marginTop:"10px",
            padding: "10px",
            // paddingTop:'5px',
          }}
        >
          <Grid container spacing={2}>
            {(fetching || !data)? (
              <TableContainer component={Paper}>
                {"يرجى الانتظار قليلا حتى يتم جلب البيانات ..."}
                <LinearProgress />
              </TableContainer>
            ) : (
              data?.data?.length > 0?
              <BalanceCustRPTTable {...{ data: data?.data?? [], viewHandle: viewHandle }} />
              : <Typography variant={"h6"}  style={{textAlign:"center", width:"100%", marginTop:10}}>
              {"Not found Orders Yet"}
            </Typography>
            )}

          </Grid>
        </Container>
      </Typography>
    </div>
  );
}
